"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultColumnFilter = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
/**
 * Textbox input for column filter
 *
 * @param param0 description of the filtered column
 * @returns
 */
const DefaultColumnFilter = ({ column: { filterValue, _preFilteredRows, setFilter } }) => {
    return (react_1.default.createElement("input", { value: filterValue || '', onChange: (e) => {
            setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }, placeholder: '' }));
};
exports.DefaultColumnFilter = DefaultColumnFilter;
//# sourceMappingURL=TableFilters.js.map